export default "__VITE_ASSET__b3214e2d__"